// TPICAP Hosted Development Environment
const host = 'https://europe-west2-tpicap-tca-polina.cloudfunctions.net/';

const dashboards = {
  fixedincome: {
    names: {
      summary: 'Summary',
      tradedetails: 'Trade Details',
      outliers: 'Outliers',
      pmoverview: 'PM Overview',
      traderoverview: 'Trader Overview',
    },
    ids: {
      summary: `b4e070f8-3194-4924-a167-28411a2eb6d4`,
      tradedetails: `0ffb1a06-1d97-4f26-95c5-ffccd153d6f8`,
      outliers: `e5493c87-a63f-44d9-a03b-79777bb2b389`,
      pmoverview: `0bf1d721-bcd6-44b8-a39b-4debed0d5a90`,
      traderoverview: `5ec05386-46f2-4ce4-a824-02901389d9bd`,
    },
    worksheetId: `fd59b959-4458-4f2f-b759-9931870bf995`,
  },
  fx: {
    names: {
      summary: 'Summary',
      tradedetails: 'Trade Details',
      outliers: 'Outliers',
      pmoverview: 'PM Overview',
      traderoverview: 'Trader Overview',
    },
    ids: {
      summary: `6a137fab-6cad-4129-92b9-778f01aa434e`,
      tradedetails: `5023493e-a2d4-4932-aa92-9e57109103e1`,
      outliers: `d51bb235-73f6-4b8e-98cd-6fa28b848bd7`,
      pmoverview: `na`,
      traderoverview: `na`,
    },
    worksheetId: `ca098e13-d20f-4e2f-9c3d-89b39f6e6635`,
  },
  fxforward: {
    names: {
      summary: 'Summary',
      tradedetails: 'Trade Details',
      outliers: 'Outliers',
      pmoverview: 'PM Overview',
      traderoverview: 'Trader Overview',
    },
    ids: {
      summary: `353d9f45-b507-46a7-86e0-9a2ad758059a`,
      tradedetails: `1d7804f3-54bb-4980-a1ac-bd946117677f`,
      outliers: `2b4f05bd-2b48-49ee-a662-7ec615271f15`,
      pmoverview: `na`,
      traderoverview: `na`,
    },
    worksheetId: `4f874cbd-fbd0-4472-b475-def1e0aa9f61`,
  },
  irs: {
    names: {
      summary: 'Summary',
      tradedetails: 'Trade Details',
      outliers: 'Outliers',
      pmoverview: 'PM Overview',
      traderoverview: 'Trader Overview',
    },
    ids: {
      summary: '5f6981b9-d924-44fe-bec5-ec0c44298d85',
      tradedetails: 'cfe8c345-f161-472c-a2e6-fc74f0672f7c',
      outliers: '6db2e0ec-ebe5-4e5f-9f9e-8eaa25defe90',
      pmoverview: 'na',
      traderoverview: 'na',
    },
    worksheetId: `538c7f74-dbcd-4b98-bb25-37ae7e4d53b0`,
  },
};

const config = {
  uploadsItemsPerPage: 7,
  uploadsPaginationItems: 10,
  uploadsPreviewColumns: 8,
  bepActiveFlag: true,
  repLinearActiveFlag: true,
  fepSpotActiveFlag: true,
  fepForwardsActiveFlag: true,
  fepNonLinearActiveFlag: false,
  endpoints: {
    uploadDetails: `${host}/upload-details`,
    getUploadUrl: `${host}/get-upload-url`,
    uploads: `${host}/uploads`,
    mapUpload: `${host}/map-upload`,
    downloadFile: `${host}/download-file`,
    deleteIngest: `${host}/delete-ingest`,
    cancelIngest: `${host}/cancel-ingest`,
    requestAccount: `${host}/request-account`,
    approveVerificationReport: `${host}/approve-verification-report`,
    getUserData: `${host}/get-user-data`,
    verifyUserToken: `${host}/verify-user-token`,
    getThoughtSpotToken: `${host}/get-thoughtspot-token`,
    getJittoEmbedToken: `${host}/get-jitto-embed-token`,
    preferences: `${host}/user-preferences`,
    getLogUrl: `${host}/get-log-url`,
    mappingAdmin: `${host}/mapping-admin`,
    mappingAdminValues: `${host}/mapping-admin-values`,
    getMappingAuditTrail: `${host}/mapping-audit-trail`,
  },
  uploadValidationPollInterval: 5000,
  oktaAccountManagementLink:
    'https://parameta-accounts.okta.com/enduser/settings?fromLogin=true',
  // Jitto Answer embed (ANS-545): off until this env's backend is configured
  // (Terraform jitto_answer_url). When on, a
  // dashboard with an embedded uuid in config/jittoDashboards.json renders from
  // Jitto Answer and every other one shows a notice; nothing asks ThoughtSpot
  // (no ThoughtSpot embed, AI Assistant, dashboard builder or logout). When off,
  // all of it is ThoughtSpot.
  jittoEmbedActiveFlag: false,
  // The tenant's own Jitto host: @jitto/analyze-embed frames only <this>/embed (ANS-678).
  jittoEmbedOrigin: 'https://embed.tpicap.jitto.dev',
  // Jitto applies host filters (filters on mount, setFilters): @jitto/analyze-embed 0.3.0 (ANS-801).
  // Only read with the Jitto embed on: before turning that on here, this environment's Jitto must
  // run jitto-analyze#540 with EMBED_HOST_FILTERS on and single_choice listed, and its token
  // function must pass filter_bar on, or every dashboard with Ccy fails.
  jittoHostFilters: true,
  thoughtSpotHost: 'https://parameta.thoughtspot.cloud',
  authProvider: 'okta',
  okta: {
    issuer: 'https://parameta-accounts.okta.com/oauth2/default',
    clientId: '0oa131qon7hilhvva417',
    pkce: false,
    tokenManager: {
      storage: 'cookie',
    },
    cookies: {
      sessionCookie: true,
    },
  },
  fxCurrencies: [
    'USD',
    'CAD',
    'CNY',
    'CHF',
    'AUD',
    'JPY',
    'EUR',
    'GBP',
    'NZD',
    'HKD',
    'SEK',
    'SGD',
  ].sort(),
  requestAccountActionURL:
    'https://test.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8',
  requestAccountRetURL:
    'https://tca-dev.dhb-npd.tpicapcloud.com/requestaccount',
  dashboards,
};

export default config;
